<section class="app-panel telegram">
  <header class="head">
    <h2 class="section-title">
      <mat-icon>send</mat-icon>
      Telegram alerts
    </h2>
    <span class="status" [class.on]="configured">
      <span class="dot"></span>
      {{ configured ? 'Bot connected to the admin group' : 'Bot not configured' }}
    </span>
    <span class="spacer"></span>
    @if (canEdit && configured) {
      <button mat-stroked-button (click)="sendTest()" [disabled]="testing">
        <mat-icon>science</mat-icon>
        Send test message
      </button>
    }
  </header>

  @if (!configured) {
    <p class="muted note">Alerts start once the server has <code>TELEGRAM_BOT_TOKEN</code> and <code>TELEGRAM_ADMIN_CHAT_ID</code>. The switches below are kept until then.</p>
  }

  @if (config) {
    <p class="muted note">If the admin group has topics, each alert can post in its own: send <code>/topic</code> in a topic
      to get its number and enter it here. Empty posts in General.</p>

    <div class="alerts">
      @for (a of alerts; track a.name) {
        <div class="alert-row">
          <div class="alert-text">
            <div class="alert-label">{{ a.label }}</div>
            <div class="alert-hint muted">{{ a.hint }}</div>
          </div>
          <div class="alert-controls">
            <label class="topic">
              <span class="muted">Topic</span>
              <input type="number" min="0" step="1" placeholder="General" [(ngModel)]="topics[a.name]"
                (blur)="saveTopic(a.name)" (keydown.enter)="saveTopic(a.name)" [disabled]="!canEdit || saving"
                [attr.aria-label]="a.label + ' topic'" />
            </label>
            <mat-slide-toggle [ngModel]="config.alerts[a.name]" (ngModelChange)="toggle(a.name, $event)"
              [disabled]="!canEdit || saving" [attr.aria-label]="a.label"></mat-slide-toggle>
          </div>
        </div>
      }
    </div>

    <mat-form-field appearance="outline" class="digest">
      <mat-label>Payment digest at most every</mat-label>
      <input matInput type="number" min="5" step="5" [(ngModel)]="digestMinutes" (blur)="saveDigest()"
        (keydown.enter)="saveDigest()" [disabled]="!canEdit || saving" />
      <span matTextSuffix class="muted">min</span>
      <mat-hint>At least 5. Saved when you leave the field.</mat-hint>
    </mat-form-field>

    <h3 class="sub-title">
      <mat-icon>storefront</mat-icon>
      Supplier bot
    </h3>
    <p class="muted note">Suppliers link their Telegram from <b>Profile</b> in the supplier portal, then get these
      notices in Farsi and can check what they are owed, their accounts and their contracts.</p>

    <div class="alerts">
      <div class="alert-row master">
        <div>
          <div class="alert-label">Supplier bot</div>
          <div class="alert-hint muted">Off: suppliers cannot link and get nothing; a message to the bot says it is not active</div>
        </div>
        <mat-slide-toggle [ngModel]="config.supplier_bot_enabled" (ngModelChange)="toggleSupplierBot($event)"
          [disabled]="!canEdit || saving" aria-label="Supplier bot"></mat-slide-toggle>
      </div>
      @for (n of supplierNotices; track n.name) {
        <div class="alert-row" [class.dimmed]="!config.supplier_bot_enabled">
          <div>
            <div class="alert-label">{{ n.label }}</div>
            <div class="alert-hint muted">{{ n.hint }}</div>
          </div>
          <mat-slide-toggle [ngModel]="config.supplier_notices[n.name]" (ngModelChange)="toggleNotice(n.name, $event)"
            [disabled]="!canEdit || saving || !config.supplier_bot_enabled" [attr.aria-label]="n.label"></mat-slide-toggle>
        </div>
      }
    </div>
  }
</section>
